import PriorityLevelItemsBlock from "components/priorityLevels/priorityLevelItemsBlock/PriorityLevelItemsBlock";
import { type ModalWithStepsStep } from "../../../../modal/ModalWithSteps";
import { type PriorityLevel } from "../../../../../interfaces";

import "./priorityLevelsStep.scss";
import { type PeopleType } from "features/Library/PeopleAssignments/types";

interface PriorityLevelsStepProps extends ModalWithStepsStep {
  peopleType: PeopleType;
  priorityItems: PriorityLevel[];
  onIsDataValidChange: Function;
  onItemsUpdate: Function;
}

function PriorityLevelsStep(props: PriorityLevelsStepProps) {
  const { priorityItems, onItemsUpdate, onIsDataValidChange, peopleType } = props;

  return (
    <div className="priority-levels-step">
      <PriorityLevelItemsBlock
        peopleType={peopleType}
        items={priorityItems}
        onItemsUpdate={onItemsUpdate}
        onIsDataValidChange={onIsDataValidChange}
      />
    </div>
  );
}

export default PriorityLevelsStep;
